import Api from '@/services/api.js';

export default {
  countMasterFile(masterFile) {
    return Api.get(`statistics/count/${masterFile}`);
  },

}